import { getFullName } from "@bounce/util"

export type ReviewUser = {
  firstName: string | null
  lastName: string | null
}

export const getReviewFullName = (user: ReviewUser) =>
  !user.lastName ? getFullName(user) : getFullName({ ...user, lastName: `${user.lastName.charAt(0)}.` })
